(function($) {

  $(".otwieracz").click(function() {
    $("html").toggleClass('menu-otwarte');
  });

  jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
  };

  $("body.home").addClass('show-page');

  const cvLightGallery = function() {

    $(".gallery").lightGallery({
      caption : true,
      desc : true,
      rel: false,
      autoplay: false,
      loop: true,
      download: false,
      closable: false,
      fullScreen: false,
      share: false,
      thumbnail: true,
      selector: '.zoom'
    });

    $("a.img").lightGallery({
      caption : true,
      desc : true,
      rel: false,
      autoplay: false,
      loop: true,
      download: false,
      closable: false,
      fullScreen: false,
      share: false,
      thumbnail: false,
      selector: 'this'
    });

  };

  const cvSlickSlider = function() {

    if( $('#opinie-slider').length ) {
      
      $('#opinie-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: false,
        autoplay: false,
        centerMode: false,
        variableWidth: false,
        adaptiveHeight: true,
        arrows: true,
        slidesToShow: 1,
        swipeToSlide: true,
        slidesToScroll: 1,
        draggable: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        // lazyLoad: 'progressive',
        appendDots: $('#opinie-slider-controls'),
        appendArrows: $('#opinie-slider-controls'),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              appendDots: $('#opinie-slider-controls'),
              appendArrows: $('#opinie-slider-controls'),
            }
          },
          {
            breakpoint: 992,
            settings: {
              appendDots: $('#opinie-slider-controls-mobile'),
              appendArrows: $('#opinie-slider-controls-mobile'),
            }
          }
        ]
      });

    }

    $('.opinie-arrows button').click(function() {
      const anchor = document.querySelector('#opinie')
      const anchorPos = anchor.getBoundingClientRect().top + window.pageYOffset
      window.scroll({
        top: anchorPos,
        behavior: 'smooth'
      });
    });

    $('#opinie-slider-controls-mobile button').click(function() {
      const anchor = document.querySelector('#opinie')
      const anchorPos = anchor.getBoundingClientRect().top + window.pageYOffset
      window.scroll({
        top: anchorPos,
        behavior: 'smooth'
      });
    });

    $('.left-arrow').on('click', function() {
      $('#opinie-slider').slick("slickPrev");
    });
    $('.right-arrow').on('click', function() {
      $('#opinie-slider').slick("slickNext");
    });


    if( $('#galeriaCase').length ) {
      
      $('#galeriaCase .gallery').slick({
        dots: true,
        infinite: false,
        speed: 500,
        fade: false,
        autoplay: false,
        centerMode: false,
        variableWidth: false,
        adaptiveHeight: false,
        arrows: true,
        slidesToShow: 1,
        swipeToSlide: true,
        slidesToScroll: 1,
        draggable: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        // lazyLoad: 'progressive',
        appendDots: $('#gallery-slider-controls'),
        appendArrows: $('#gallery-slider-controls')
      });

    }

    if( $('.slider-klienci').length ) {

      if ($(window).width() < 992) {
        $('.slider-klienci').slick({
          dots: false,
          infinite: true,
          speed: 500,
          fade: false,
          autoplay: true,
          centerMode: false,
          variableWidth: false,
          adaptiveHeight: true,
          arrows: false,
          slidesToShow: 4,
          swipeToSlide: true,
          slidesToScroll: 1,
          draggable: true,
          pauseOnFocus: false,
          pauseOnHover: false,
          // lazyLoad: 'progressive',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
      } else {
        $('.slider-klienci').remove();
      }

    }

    
    $slick_realizacjeslidernew = $('#realizacje-slider-new');
    settings = {
      dots: true,
        infinite: true,
        speed: 500,
        fade: false,
        autoplay: false,
        centerMode: false,
        variableWidth: false,
        arrows: true,
        swipeToSlide: true,
        draggable: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        appendDots: $('#realizacje-controls'),
        appendArrows: $('#realizacje-controls'),
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              appendDots: $('#realizacje-controls'),
              appendArrows: $('#realizacje-controls'),
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              appendDots: $('#realizacje-controls-mobile'),
              appendArrows: $('#realizacje-controls-mobile'),
            }
          }
        ]
    }
    if( $('#realizacje-slider-new').length ) {
      $slick_realizacjeslidernew.slick(settings);

      $('.left-arrow').on('click', function() {
        $('#realizacje-slider-new').slick("slickPrev");
      });
      $('.right-arrow').on('click', function() {
        $('#realizacje-slider-new').slick("slickNext");
      });
    }



    if( $('#realizacje-slider').length ) {
      
      $('#realizacje-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: false,
        autoplay: false,
        centerMode: false,
        variableWidth: false,
        arrows: true,
        swipeToSlide: true,
        draggable: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        // lazyLoad: 'progressive',
        appendDots: $('#realizacje-controls'),
        appendArrows: $('#realizacje-controls'),
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              appendDots: $('#realizacje-controls'),
              appendArrows: $('#realizacje-controls'),
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              appendDots: $('#realizacje-controls-mobile'),
              appendArrows: $('#realizacje-controls-mobile'),
            }
          }
        ]
      });

    }

    $('#realizacje-controls-mobile').click(function() {
      const anchor = document.querySelector('#realizacje')
      const anchorPos = anchor.getBoundingClientRect().top + window.pageYOffset
      window.scroll({
        top: anchorPos,
        behavior: 'smooth'
      });
    });
    
    $('.left-arrow').on('click', function() {
      $('#realizacje-slider').slick("slickPrev");
    });
    $('.right-arrow').on('click', function() {
      $('#realizacje-slider').slick("slickNext");
    });

    if( $('#audyt-slider').length ) {
      
      $('#audyt-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: false,
        autoplay: false,
        centerMode: false,
        variableWidth: false,
        adaptiveHeight: true,
        arrows: true,
        slidesToShow: 1,
        swipeToSlide: true,
        slidesToScroll: 1,
        draggable: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        // lazyLoad: 'progressive',
        appendDots: $('#audyt-slider-controls'),
        appendArrows: $('#audyt-slider-controls')
      });

    }

    $('.next-table').on('click', function() {
      $('#audyt-slider').slick("slickNext");
    });


    if( $('#wsparcie-slider').length ) {
      
      $('#wsparcie-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: false,
        autoplay: false,
        centerMode: false,
        variableWidth: false,
        adaptiveHeight: true,
        arrows: true,
        slidesToShow: 1,
        swipeToSlide: true,
        slidesToScroll: 1,
        draggable: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        // lazyLoad: 'progressive',
        appendDots: $('#wsparcie-slider-controls'),
        appendArrows: $('#wsparcie-slider-controls')
      });

    }

    if( $('.logotypy-partnerzy-rankingu--slider').length ) {
      
      $('.logotypy-partnerzy-rankingu--slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        arrows: true,
        swipeToSlide: true,
        draggable: true,
        slidesToShow: 5,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });

    }

    if( $('.logotypy-media--slider').length ) {
      
      $('.logotypy-media--slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        arrows: true,
        swipeToSlide: true,
        draggable: true,
        slidesToShow: 5,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });

    }


    if( $('#moi-goscie-slider').length ) {
      
      $('#moi-goscie-slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        arrows: true,
        swipeToSlide: true,
        draggable: true,
        slidesToShow: 6,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2.5
            }
          }
        ]
      });

    }


    $('.next-table').on('click', function() {
      $('#wsparcie-slider').slick("slickNext");
    });
    
  };


  (function cvInit() {

    cvLightGallery();
    cvSlickSlider();

  })();

  $slick_naszeopinie = $('.co-mowia-klienci .opinie-bottom');
  settings = {
    dots: false,
    infinite: true,
    speed: 500,
    fade: false,
    autoplay: false,
    centerMode: false,
    variableWidth: false,
    adaptiveHeight: false,
    arrows: true,
    slidesToShow: 1,
    swipeToSlide: true,
    slidesToScroll: 1,
    draggable: true,
    pauseOnFocus: true,
    pauseOnHover: true,
    responsive: [
    ]
  }
  $slick_naszeopinie.slick(settings);
  // reslick only if it's not slick()
  // $(window).on('resize', function() {
  //   // if ($(window).width() < 992) {
  //   //   if ($slick_naszeopinie.hasClass('slick-initialized')) {
  //   //     $slick_naszeopinie.slick('unslick');
  //   //   }
  //   //   return
  //   // }
  //   if (!$slick_naszeopinie.hasClass('slick-initialized')) {
  //     return $slick_naszeopinie.slick(settings);
  //   }
  // });


  $slick_logadlaczegomy = $('.logotypy-dlaczegomy--slider');
  sl_settings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    swipeToSlide: true,
    draggable: true,
    fade: false,
    // autoplay: false,
    // centerMode: false,
    // variableWidth: false,
    // adaptiveHeight: true,
    // arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
    ]
  }
  if ($(window).width() < 992) {
    $slick_logadlaczegomy.slick(sl_settings);
  }
  // reslick only if it's not slick()
  $(window).on('resize', function() {
    if ($(window).width() > 991) {
      if ($slick_logadlaczegomy.hasClass('slick-initialized')) {
        $slick_logadlaczegomy.slick('unslick');
      }
      return
    }
    if (!$slick_logadlaczegomy.hasClass('slick-initialized')) {
      return $slick_logadlaczegomy.slick(sl_settings);
    }
  });



  var $element = $('#header'),
      className = 'fixed';

  $(document).scroll(function() {
    if ($(document).scrollTop() >= 50) {
      $element.addClass(className);
    } else {
      $element.removeClass(className);
    }
  });
  $(document).ready(function() {
    if (window.pageYOffset >= 50) {
      $element.addClass(className);
    } else {
      $element.removeClass(className);
    }
  });

  if ($(window).width() < 992) {
    $("<span class='switch'></span>").insertAfter(".menu-item-has-children > a");
    $(".menu-item-has-children > a").attr('href', '#!');
    
    $(".switch").click(function() {
      $(this).next(".sub-menu").slideToggle();
      $(this).parent().toggleClass("submenu-open");
    });

    $(".with-switch > h5").append("<span class='switch'></span>");
    $(".with-switch > h5").click(function() {
      $(this).next("div").slideToggle();
      $(this).parent().toggleClass('active-switch');
    });

  }

  // zakladki
  if ($(window).width() < 992) {
    $("#ulatwiamy-zakladki .opis").removeClass("aktywna");
    $("#ulatwiamy-zakladki .opis .tytul").removeClass("on");
    $("#ulatwiamy-zakladki .opis .podpis").removeClass("widac");

    $("#ulatwiamy-zakladki .opis").click(function() {
      $(this).toggleClass("aktywna");
      $(this).children(".tytul").toggleClass("on");
      $(this).children(".podpis").toggleClass("widac");
    });
  }

  // zakladki
  if ($(window).width() > 991) {
    $("#ulatwiamy-zakladki-left .opis").click(function() {
      var opisid = $(this).attr("data-id");
      $("#ulatwiamy-zakladki-left .opis").removeClass("aktywna");
      $("#ulatwiamy-zakladki-left .opis .tytul").removeClass("on");
      $("#ulatwiamy-zakladki-left .opis .podpis").removeClass("widac");
      $(this).toggleClass("aktywna");
      $(this).children(".tytul").toggleClass("on");
      $(this).children(".podpis").toggleClass("widac");

      $("#ulatwiamy-zakladki .opis").removeClass("aktywna");
      $("#ulatwiamy-zakladki #" + opisid).addClass("aktywna");
      // $("#ulatwiamy-zakladki .opis").attr(opis).addClass("aktywna");
    });
  }
  
  if ($(window).width() < 992) {
    $("#jak-proces-zakladki .opis").removeClass("aktywna");
    $("#jak-proces-zakladki .opis .tytul").removeClass("on");
    $("#jak-proces-zakladki .opis .podpis").removeClass("widac");

    $("#jak-proces-zakladki .opis").click(function() {
      $(this).toggleClass("aktywna");
      $(this).children(".tytul").toggleClass("on");
      $(this).children(".podpis").toggleClass("widac");
    });
  }

  // zakladki
  if ($(window).width() > 991) {
    $("#jak-proces-zakladki-top .opis").click(function() {
      var opisid = $(this).attr("data-id");
      $("#jak-proces-zakladki-top .opis").removeClass("aktywna");
      $("#jak-proces-zakladki-top .opis .tytul").removeClass("on");
      $("#jak-proces-zakladki-top .opis .podpis").removeClass("widac");
      $(this).toggleClass("aktywna");
      $(this).prevAll().toggleClass("aktywna");
      $(this).children(".tytul").toggleClass("on");
      $(this).prevAll().children(".tytul").toggleClass("on");
      $(this).children(".podpis").toggleClass("widac");
      $(this).prevAll().children(".podpis").toggleClass("widac");

      $("#jak-proces-zakladki .opis").removeClass("aktywna");
      $("#jak-proces-zakladki #" + opisid).addClass("aktywna");
      // $("#ulatwiamy-zakladki .opis").attr(opis).addClass("aktywna");
    });
  }

  $("#opis-2-btn").click(function() {
    $("#opis-2").addClass("aktywna");
    $("#opis-1").removeClass("aktywna");
    $("#opis-2-link").addClass("aktywna");
    $(".tytul-2").addClass("on");
  });
  $("#opis-3-btn").click(function() {
    $("#opis-3").addClass("aktywna");
    $("#opis-2").removeClass("aktywna");
    $("#opis-3-link").addClass("aktywna");
    $(".tytul-3").addClass("on");
  });
  $("#opis-4-btn").click(function() {
    $("#opis-4").addClass("aktywna");
    $("#opis-3").removeClass("aktywna");
    $("#opis-4-link").addClass("aktywna");
    $(".tytul-4").addClass("on");
  });
  $("#opis-5-btn").click(function() {
    $("#opis-5").addClass("aktywna");
    $("#opis-4").removeClass("aktywna");
    $("#opis-5-link").addClass("aktywna");
    $(".tytul-5").addClass("on");
  });
  $("#opis-6-btn").click(function() {
    $("#opis-6").addClass("aktywna");
    $("#opis-5").removeClass("aktywna");
    $("#opis-6-link").addClass("aktywna");
    $(".tytul-6").addClass("on");
  });
  
  $("#przelaczniki .support-switch").click(function() {
    var opisid = $(this).attr("data-id");
    $("#przelaczniki .support-switch").removeClass("on");
    $(this).addClass("on");
    $(".support-section").hide();
    $("#" + opisid).show();
  });

  $("#regularSupportBtn").click(function() {
    if (!$("#regularSupport").hasClass("on")) {
      $("#smallHelp").removeClass("on");
      $("#regularSupport").addClass("on");
      if ($("#small-help")) {
        $("#small-help").hide();
        $("#regular-support").show();
      }
    }
  });

  $("#smallHelpBtn").click(function() {
    if (!$("#smallHelp").hasClass("on")) {
      $("#regularSupport").removeClass("on");
      $("#smallHelp").addClass("on");
      if ($("#regular-support")) {
        $("#regular-support").hide();
        $("#small-help").show();
      }
    }
  });

  if ($(window).width() < 992) {
    $(".support-section .columns p").click(function() {
      $(this).toggleClass("on");
      $(this).children("span.ard").text(function(i, text){ return text === "Rozwiń" ? "Zwiń" : "Rozwiń"; });
      $(this).next("ul").toggle();
    });
  }

  $("#przelaczniki-cennik .support-cennik-switch").click(function() {
    var opisid = $(this).attr("data-id");
    $("#przelaczniki-cennik .support-cennik-switch").removeClass("on");
    $(this).addClass("on");
    $(".support-cennik-section").hide();
    $("#" + opisid).show();
  });

  $(".tab-box-head").click(function(e) {
    e.preventDefault();
    $(this).toggleClass("on");
    $(this).next(".tab-box-main").toggle();
  });

  $(".accordionHead").click(function(e) {
    e.preventDefault();
    $(this).toggleClass("on");
    $(this).next(".accordionContent").toggle();
  });

  $( ".trescpostu .teksty > p:contains('GF:')" ).addClass("gf");

  if ($(".wp-tag-cloud li").length > 10) {
    $('.wp-tag-cloud li:gt(7)').nextAll().hide();
    $("#tags-list span.ard").show();
  }

  $("#tags-list span.ard").click(function() {
    $(this).text(function(i, text){ return text === "Rozwiń" ? "Zwiń" : "Rozwiń"; });
    $("#tags-list").toggleClass("on");
    $('.wp-tag-cloud li:gt(7)').nextAll().toggle();
  });

  if ( $('.wp-tag-cloud li').hasClass('active-tag') ) { 
    $('.reset').show(); 
  } else {
    $('.reset').hide();
  }

  ( function() {
    var youtube = document.querySelectorAll( ".youtube" );
    for (var i = 0; i < youtube.length; i++) {
      var source = "https://i.ytimg.com/vi/"+ youtube[i].dataset.embed +"/maxresdefault.jpg";
      var image = new Image();
          image.src = source;
          image.addEventListener( "load", function() {
            youtube[ i ].appendChild( image );
          }( i ) );
          youtube[i].addEventListener( "click", function() {
            var iframe = document.createElement( "iframe" );
                iframe.setAttribute( "frameborder", "0" );
                iframe.setAttribute( "allowfullscreen", "" );
                iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );
                this.innerHTML = "";
                this.appendChild( iframe );
          } );
    };
  } )();

  $('#czego-potrzebujesz a').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 100;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 1000);
    e.preventDefault();
  });

  $('#mainimage a').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });

  $('#pagetop.opinions a').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });

  $('#pagetop a.btn').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });

  $('.post-template .wstepniak ul li a').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });

  $('#oferta-prestashop .box a').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });

  $('.kariera .link-to-offer').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });

  $('.gfratczak .link-to-contact').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });

  $('.kariera.kariera-oferta-pracy .link-to-form').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });

  $('.ecom-m .emhref a').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });

  $('#ebook').click(function(e){
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#pobierzEbooka").offset().top - 10
  }, 500);
    e.preventDefault();
  });

  $(".link-box-head").click(function() {
    $(this).next(".link-box-opis").toggleClass("on");
    $(this).parent().toggleClass("add-shadow");
  });

  // rankingi przewijanie tabeli desktopowo
  const slider = document.querySelector('.ranking-table');
  let isDown = false;
  let startX;
  let scrollLeft;

  if (slider) {
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX);
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  function calculateScrollbarWidth() {
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
  }

  $(document).ready(function(){
    calculateScrollbarWidth();
  });
  
  $(window).resize(function(){
    calculateScrollbarWidth();
  });

  // rankingi tabela "więcej/mniej trigger"
  const XX = 200;
  $('.ranking-table td span').filter(function() {
      return $(this).text().length > XX;
  }).addClass('someClass');
  if($('.someClass')) {
    $( '<div class="open-trigger">więcej...</div>' ).insertAfter( ".someClass" );
  }
  $(".open-trigger").on("click", function() {
    return $(this).prev().toggleClass("open"),
    $(this).prev().hasClass("open") ? $(this).html("mniej...") : $(this).html("więcej..."),
    !1
  });

  $('.accordion-content').hide();
  $('.accordion-toggle').click(function() {
    $('.accordion-toggle').removeClass('opened');
    $(this).addClass('opened');
    $(this).next().slideToggle('fast');
    $(".accordion-content").not($(this).next()).slideUp('fast');
  });

  if (window.location.href.indexOf("?tag=") > -1) {
    $("body").addClass("has-tag");
  }

  $(".wsparcietechniczne #czego-potrzebujesz .box-head, .wsparcietechniczne #swt .box-head").click(function() {
    $(this).toggleClass('on');
    $(this).find('.ard').text(function(i, text){
      return text === "szczegóły" ? "zwiń" : "szczegóły";
    });
    $(this).next('.box-main').toggle();
  });

  $(".wsparcietechniczne #zadanie .box-head").click(function() {
    $(this).toggleClass('on');
    $(this).find('.ard').text(function(i, text){
      return text === "zobacz kroki" ? "zwiń" : "zobacz kroki";
    });
    $(this).next('.box-main').toggle();
  });

  // $(".prestashop #oferta-prestashop .box-head a").click(function() {
  //   $(this).toggleClass('on');
  //   $(this).text(function(i, text){
  //     return text === "szczegóły" ? "zwiń" : "szczegóły";
  //   });
  //   $(this).parent().next('.box-main').toggle();
  // });

//strzałki opinie i realizacje

  function opinieSliderArrowHeight() {
    $('#opinie .left-arrow').css({'max-height': $('#opinie-slider').outerHeight()});
    $('#opinie .right-arrow').css({'max-height': $('#opinie-slider').outerHeight()});
    $('#opinie .left-arrow').css({'background-position-y': $('#opinie-slider .opinia-img').outerHeight() });
    $('#opinie .right-arrow').css({'background-position-y': $('#opinie-slider .opinia-img').outerHeight() });
  }
  $(document).ready(function(){
    opinieSliderArrowHeight();
  });
  $(window).resize(function(){
    opinieSliderArrowHeight();
  });

  function realizacjeSliderArrowHeight() {
    $('#realizacje .left-arrow').css({'max-height': $('#realizacje-slider').outerHeight()});
    $('#realizacje .right-arrow').css({'max-height': $('#realizacje-slider').outerHeight()});
    $('#realizacje .left-arrow').css({'background-position-y': $('#realizacje-slider .real-obr').outerHeight() + $('#realizacje .container .row.mobile').outerHeight()});
    $('#realizacje .right-arrow').css({'background-position-y': $('#realizacje-slider .real-obr').outerHeight() + $('#realizacje .container .row.mobile').outerHeight()});
  }
  $(document).ready(function(){
    realizacjeSliderArrowHeight();
  });
  $(window).resize(function(){
    realizacjeSliderArrowHeight();
  });
  
  function handleTable(childSelector, parentSelector) {
    if ($(childSelector).length) {
      $(`${parentSelector} .show-more`).show();
  
      $('body').on('click', `${parentSelector} .show-more`, function() {
        $(`${parentSelector} .show-more`).hide();
        $(`${parentSelector} .show-less`).show();
        $('.show-less-btns').addClass('hide-bg');
        $(`${childSelector}`).removeClass('less');
      });
  
      $('body').on('click', `${parentSelector} .show-less`, function() {
        $(`${parentSelector} .show-less`).hide();
        $(`${parentSelector} .show-more`).show();
        $('.show-less-btns').removeClass('hide-bg');
        $(`${childSelector}`).addClass('less');
      });
    }
  }
  
  //Realizacje filtry
  $(document).ready(function() {
    handleTable('.tabela-audyty-desktop', '#tabela-audyty');

    $(document).on('click', '.js-filter-item > span', function() {
      
      $('.js-filter-item > span').removeClass('active');
      $(this).addClass('active');

      if ($(this).data('category') == "all") {
        $("section").show();
      }
      if ($(this).data('category') == "153") {
        $("section").show();
        $("section[class*='realizacje_kategoria-wsparcie-ecommerce']").hide();
        $("section[class*='realizacje_kategoria-wsparcie-techniczne']").hide();
        if ($('section').hasClass("realizacje_kategoria-wdrozenia")) {
          $("section[class*='realizacje_kategoria-wdrozenia']").show();
        }
      }
      if ($(this).data('category') == "154") {
        $("section").show();
        $("section[class*='realizacje_kategoria-wdrozenia']").hide();
        $("section[class*='realizacje_kategoria-wsparcie-ecommerce']").hide();
        if ($('section').hasClass("realizacje_kategoria-wsparcie-techniczne")) {
          $("section[class*='realizacje_kategoria-wsparcie-techniczne']").show();
        }
      }
      if ($(this).data('category') == "155") {
        $("section").show();
        $("section[class*='realizacje_kategoria-wsparcie-techniczne']").hide();
        $("section[class*='realizacje_kategoria-wdrozenia']").hide();
        if ($('section').hasClass("realizacje_kategoria-wsparcie-ecommerce")) {
          $("section[class*='realizacje_kategoria-wsparcie-ecommerce']").show();
        }
      }
    });

    var numberOfItemsAll = $('.caseListSection').length;
    $('.numberOfItems-all').text(' (' + numberOfItemsAll + ')');
    var numberOfItemsWdr = $('.realizacje_kategoria-wdrozenia').length;
    $('.numberOfItems-wdrozenia').text(' (' + numberOfItemsWdr + ')');
    var numberOfItemsWT = $('.realizacje_kategoria-wsparcie-techniczne').length;
    $('.numberOfItems-wsparcie-techniczne').text(' (' + numberOfItemsWT + ')');
    var numberOfItemsWE = $('.realizacje_kategoria-wsparcie-ecommerce').length;
    $('.numberOfItems-wsparcie-ecommerce').text(' (' + numberOfItemsWE + ')');

    $('.single-realizacje .efektylista li, .single-realizacje .cozoptymalizowalismy li, .single-realizacje .optymalizacjalista li').each(function() {
      $(this).contents().wrap('<span>');
      $(this).children().wrapAll('<div class="optymalizacjali">');
    });
  });



  //Opinie filtry
  $(document).ready(function() {
    $(document).on('click', '.js-filter-op-item > span', function() {
      
      $('.js-filter-op-item > span').removeClass('active');
      $(this).addClass('active');

      if ($(this).data('category') == "all") {
        console.log("all");
        $("div[class*='opinieListSection']").show();
      }
      if ($(this).data('category') == "238") {
        console.log("238");
        $("div[class*='opinieListSection']").show();
        $("div[class*='opinie_kategoria-wsparcie-ecommerce']").hide();
        $("div[class*='opinie_kategoria-wsparcie-techniczne']").hide();
        if ($('div').hasClass("opinie_kategoria-wdrozenia")) {
          $("div[class*='opinie_kategoria-wdrozenia']").show();
        }
      }
      if ($(this).data('category') == "236") {
        $("div[class*='opinieListSection']").show();
        $("div[class*='opinie_kategoria-wdrozenia']").hide();
        $("div[class*='opinie_kategoria-wsparcie-ecommerce']").hide();
        if ($('div').hasClass("opinie_kategoria-wsparcie-techniczne")) {
          $("div[class*='opinie_kategoria-wsparcie-techniczne']").show();
        }
      }
      if ($(this).data('category') == "237") {
        $("div[class*='opinieListSection']").show();
        $("div[class*='opinie_kategoria-wsparcie-techniczne']").hide();
        $("div[class*='opinie_kategoria-wdrozenia']").hide();
        if ($('div').hasClass("opinie_kategoria-wsparcie-ecommerce")) {
          $("div[class*='opinie_kategoria-wsparcie-ecommerce']").show();
        }
      }
    });

    var numberOfItemsOpAll = $('.opinieListSection').length;
    $('.numberOfOpItems-all').text(' (' + numberOfItemsOpAll + ')');
    var numberOfItemsOpWdr = $('.opinie_kategoria-wdrozenia').length;
    $('.numberOfOpItems-wdrozenia').text(' (' + numberOfItemsOpWdr + ')');
    var numberOfItemsOpWT = $('.opinie_kategoria-wsparcie-techniczne').length;
    $('.numberOfOpItems-wsparcie-techniczne').text(' (' + numberOfItemsOpWT + ')');
    var numberOfItemsOpWE = $('.opinie_kategoria-wsparcie-ecommerce').length;
    $('.numberOfOpItems-wsparcie-ecommerce').text(' (' + numberOfItemsOpWE + ')');

  });

  function initGaEventsTriggers() {
    // if (typeof gtag === 'undefined') {
    //   console.error('Brak gtaga !!!');
    //   return;
    // }
  
    $('body').on('click', '#menu-nowe-menu .menu-item a', function (e) {
      var label = this.href.replace('https://convertis.pl', '');
      gtagEvent('click_main_menu_horiz', 'click_text', label);
      delayChangeLocation(this, e);
    });
  
    $('body').on('click', '#menu-nowe-menu #menu-item-3033 a', function (e) {
      var label = this.href.replace('https://convertis.pl', '');
      gtagEvent('click_main_menu_tech_support', 'click_text', label);
      delayChangeLocation(this, e);
    });
  
    $('body').on('click', '#menuglowne > a.btn', function (e) {
      var label = this.href.replace('https://convertis.pl', '');
      gtagEvent('click_header_meet_us', 'click_text', label);
      delayChangeLocation(this, e);
    });
  
    $('body').on('click', '#grzegorz-footer a.btn', function (e) {
      var label = this.href.replace('https://convertis.pl', '');
      gtagEvent('click_footer_meet_us', 'click_text', label);
      delayChangeLocation(this, e);
    });
  
    $('body').on('click', '.home #mainimage a.btn', function (e) {
      gtagEvent('click_home_see_details', 'click_text', 'details');
      delayChangeLocation(this, e);
    });

  }
  
  $(document).ready(function () {
    initGaEventsTriggers();
    openPdfFile();
  });



  function delayChangeLocation(a, e) {
    e.stopPropagation();
    e.preventDefault();
    var location = $(a).attr('href');
    setTimeout(function () {
      document.location = location;
    }, 200);
  }
  
  function gtagEvent(action, category, label) {
    // if (typeof gtag === 'undefined') {
    //   console.error('Brak gtaga !!!');
    //   return;
    // }
  
    gtag('event', action, {
      event_category: category,
      event_label: label
    });
  }
  
  document.addEventListener( 'wpcf7mailsent', function( event ) {
    window.dataLayer.push({
      "event" : "cf7submission",
      "formId" : event.detail.contactFormId,
      "response" : event.detail.inputs
    })
  }); 

  $('.page-template-wsparcie-techniczne a.btn-test').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });
  $('#rozwiazemy-problemy a.swt').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });
  $('.audyt-pagespeed #pagetop a.btn-test').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });
  $('.audyt-pagespeed #pagetop a.zamowienie-audytu').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });
  $('.prestashop #pagetop a.btn-orange').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });
  $('.konsultacja-techniczna a.anchor').click(function(e){
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - 80;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });

  $('.taxonomy-drilldown-checkboxes input').on('change', function() {
    $(this).closest('form').submit();
  });

  const pagespeedModal = $('#pagespeedModal');
  const closeModal = $('#pagespeedModal .close');
  $('#pagespeedOpenModal').click(function() {
    pagespeedModal.show();
    setTimeout(function () {
      $('#pagespeedModal .modal-content').addClass('active');
    }, 50);
  });
  closeModal.click(function() {
    pagespeedModal.hide();
    $('#pagespeedModal .modal-content').removeClass('active');
  });
  $(window).click(function(event) {
    if (event.target == pagespeedModal) {
      pagespeedModal.hide();
      $('#pagespeedModal .modal-content').removeClass('active');
    }
  });

  function openPdfFile() {
    const pdfModal = $('#pdfModal');
    const closeModal = $('#pdfModal .close');
    $('#pdfOpenModal').click(function() {
      pdfModal.show();
      setTimeout(function () {
        $('#pdfModal .modal-content').addClass('active');
      }, 50);
    });
    closeModal.click(function() {
      pdfModal.hide();
      $('#pdfModal .modal-content').removeClass('active');
    });
    $(window).click(function(event) {
      if (event.target == pdfModal[0]) {
        pdfModal.hide();
        $('#pdfModal .modal-content').removeClass('active');
      }
    });
  }


})(jQuery);